import { IGetUnregisterBillRes } from "src/service/types/pay.type";
import { useGetUnregisterBill } from "./useGetUnregisterBill";

interface IUseGetPromotionUnregisterBillProps {
  enabled?: boolean;
  onSuccess?: (serviceList: IGetUnregisterBillRes[]) => void;
  onError?: () => void;
}
// Bill페이지 에서 사용할 구매이력 정보 (PROMOTION)
export function useGetPromotionUnregisterBill(
  props: IUseGetPromotionUnregisterBillProps = {}
) {
  const { isLoading, isSuccess, data } = useGetUnregisterBill("PROMOTION", props);
  return { isLoading, isSuccess, unregisterPromotionList: data };
}
